module.exports = __webpack_public_path__ + "../resources/images/illustration_flagged-0c77165c54466c6d134215c4b252fa61.svg";